import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import RedhatACSCredentialsForm from "./RedhatACSCredentialsForm";
import RedhatACSConfigListing from "./RedhatACSConfigListing";

export default function RedhatACSPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={RedhatACSCredentialsForm}
      PullConfigListingView={RedhatACSConfigListing}
    />
  );
}
